/* import __COLOCATED_TEMPLATE__ from './buyer-feedback-option-list.hbs'; */
import Component from '@ember/component';

export default Component.extend({
  /** @inheritDoc */
  tagName: '',

  /** @param {string} */
  title: '',

  /** @param {string} */
  name: '',

  /** @param {Ember.A<Object>} */
  options: undefined,

  /** @param {string} */
  selected: undefined,

  /** @param {function} */
  onclick: undefined,

  /** @inheritDoc */
  actions: {

    /**
     *
     * @param {string} value
     */
    onclick(value) {
      this.onclick(value);
    },
  },
});
